import React from "react";
import { ImageOff } from "lucide-react";
import { EventCoverImage } from "../../components/EventCoverImage";
import { coverCandidates } from "../../utils/mediaUrl";

export { proxiedMediaUrl } from "../../utils/mediaUrl";

/** Cover URL: hero first, then logo (same as mini-app EventPosterCard). */
export function eventCoverSrc(event: {
  heroImage?: string | null;
  logoUrl?: string | null;
}): string {
  return (event.heroImage || event.logoUrl || "").trim();
}

/**
 * Exhibition preview aligned with mini-app intent:
 * 16:9 frame, 8px side padding, contain (no crop).
 */
export function AdminEventCover({
  src,
  alt,
  className = "",
  rounded = "rounded-xl",
}: {
  src: string;
  alt: string;
  className?: string;
  rounded?: string;
}) {
  const hasSrc = coverCandidates(src).length > 0;

  return (
    <div
      className={`relative w-full overflow-hidden bg-white ${rounded} ${className}`}
      style={{ aspectRatio: "16 / 9" }}
    >
      {hasSrc ? (
        <div className="absolute inset-0 flex items-center justify-center px-2">
          <EventCoverImage
            src={src}
            alt={alt}
            imgClassName="max-h-full max-w-full w-auto h-auto object-contain object-center"
          />
        </div>
      ) : (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-1 bg-gradient-to-br from-slate-50 to-slate-100 text-slate-400 px-2">
          <ImageOff size={20} strokeWidth={1.5} />
          <span className="text-[11px] text-center line-clamp-2">{alt || "Нет обложки"}</span>
        </div>
      )}
    </div>
  );
}
